export default "src/content/themes/association-wordpress-theme/img/340ec5a865146fc100dab50eede17cfd.png";